import { useSelector } from "react-redux"

const useCssVars = () => {
    const cinemaData = useSelector((state) => state.toJS().cinemaData)
    const {front, theme} = cinemaData
    const {
        custom_font_color, 
        custom_font_color_color,
        header_appearance
    } = front

    const {
        accent_color,
        accent_color_background,
        accent_color_dark,
        accent_color_footer_menu,
        accent_color_gradient,
        accent_color_titles,
        base_accent_color_footer_menu,
        border_radius_buttons,
        border_radius_posters,
        button_background_color,
        button_background_color_hover,
        button_border_style,
        button_border_style_hover,
        button_shadow,
        button_shadow_hover,
        custom_background,
        custom_button_color,
        custom_button_color_gradient,
        custom_button_color_gradient_hover,
        custom_button_color_hover,
        quick_ticket_button_background_color,
        quick_ticket_button_background_color_hover,
        quick_ticket_button_font_color,
        quick_ticket_button_text_color_hover,
        theme_colors,
        overview_filter_style,
        gradient_overwrites_accent_color,
        userbar_color,
        multitotal_style,
        slider_background_color,
        arthouse_variant
    } = theme


    const getArthouseVariantSliderColor =  arthouse_variant === "dark" ? "#222121" : "#F2F2F2"

    let cssVars = {
        "--pmkinovar-accent_color" : accent_color,
        "--pmkinovar-userbar_color" : userbar_color ? userbar_color : accent_color_background,
        "--pmkinovar-accent_color_background" : accent_color_background,
        "--pmkinovar-accent_color_dark" : accent_color_dark,
        "--pmkinovar-accent_color_footer_menu" : accent_color_footer_menu ? accent_color_footer_menu : base_accent_color_footer_menu,
        "--pmkinovar-accent_color_gradient" : accent_color_gradient,
        "--pmkinovar-accent_color_titles" : accent_color_titles,
        "--pmkinovar-base_accent_color_footer_menu" : base_accent_color_footer_menu,
        "--pmkinovar-border_radius_buttons" : border_radius_buttons,
        "--pmkinovar-border_radius_posters" : border_radius_posters,
        "--pmkinovar-custom_background" : custom_background ? custom_background : accent_color_background,
        "--pmkinovar-quick_ticket_button_background_color" : quick_ticket_button_background_color,
        "--pmkinovar-quick_ticket_button_background_color_hover" : quick_ticket_button_background_color_hover,
        "--pmkinovar-quick_ticket_button_font_color" : quick_ticket_button_font_color,
        "--pmkinovar-quick_ticket_button_text_color_hover" : quick_ticket_button_text_color_hover,
        "--pmkinovar-theme_colors" : theme_colors,
        "--pmkinovar-button_shadow" : button_shadow,
        "--pmkinovar-button_shadow_hover" : button_shadow_hover,
        "--pmkinovar-gradient_overwrites_accent_color" : gradient_overwrites_accent_color ? gradient_overwrites_accent_color : accent_color,
        // old default colors
        "--pmkinovar-color-blue-prices" : '#c40000',
        "--pmkinovar-color-trailer-typo": "#FFF",
        "--pmkinovar-color-fsk-typo": "#181818",
        "--pmkinovar-color-fsk-typo-inverted": "#fff",
        "--pmkinovar-color-fsk-0": "#FFFFFF",
        "--pmkinovar-color-fsk-3": "#f37a24",
        "--pmkinovar-color-fsk-6": "#F0EC10",
        "--pmkinovar-color-fsk-8": "#0064a5",
        "--pmkinovar-color-fsk-10": "#c766b7",
        "--pmkinovar-color-fsk-12": "#31AE3F",
        "--pmkinovar-color-fsk-14": "#8a32d1",
        "--pmkinovar-color-fsk-15": "#f39200",
        "--pmkinovar-color-fsk-16": "#36A2DC",
        "--pmkinovar-color-fsk-18": "#E51A23",
        "--pmkinovar-color-fsk-0-transparency": "#FFFFFFbf",
        "--pmkinovar-color-fsk-3-transparency": "#f37a24bf",
        "--pmkinovar-color-fsk-6-transparency": "#F0EC10bf",
        "--pmkinovar-color-fsk-8-transparency": "#0064a5bf",
        "--pmkinovar-color-fsk-10-transparency": "#c766b7bf",
        "--pmkinovar-color-fsk-12-transparency": "#31AE3Fbf",
        "--pmkinovar-color-fsk-14-transparency": "#8a32d1bf",
        "--pmkinovar-color-fsk-15-transparency": "#f39200bf",
        "--pmkinovar-color-fsk-16-transparency": "#36A2DCbf",
        "--pmkinovar-color-fsk-18-transparency": "#E51A23bf",
    }
    
    //LIGHT THEME
    if(theme_colors === "Light") {
        cssVars = {
            ...cssVars,
            "--pmkinovar-custom_font_color" : custom_font_color && custom_font_color_color ? custom_font_color_color : '#000000',
            "--pmkinovar-custom_button_color" : button_background_color,
            "--pmkinovar-custom_button_color_hover" : button_background_color_hover,
            "--pmkinovar-button_background_color" : 'transparent',
            "--pmkinovar-button_background_color_hover" : '#ffffff59',
            "--pmkinovar-button_border_style" : button_border_style ? button_border_style : '1px solid ' + button_background_color,
            "--pmkinovar-button_border_style_hover" : button_border_style_hover ? button_border_style_hover : '1px solid ' + button_background_color_hover,
            "--pmkinovar-filter_button_background_color" : 'transparent',
            "--pmkinovar-slider-background-default-color": getArthouseVariantSliderColor,
            "--pmkinovar-slider-background-colored-color": multitotal_style === 'colored' ? getArthouseVariantSliderColor : slider_background_color ? slider_background_color : "#181818",
            // old default colors
            "--pmkinovar-color-border-transparent" :'#18181833',
            "--pmkinovar-color-selection-main" :'#cecccc',
            "--pmkinovar-color-theme-main-transparent": "#ffffff80",
            "--pmkinovar-color-theme-main-more-transparent": "#ffffff59",
            "--pmkinovar-color-theme-selektor-transparent": "#ffffff45",
            "--pmkinovar-color-theme-main-contrast-light-transparent": "#0000001a",
            //needs to be like this for rgba reasons - if varaible is used please write rgb() around
            "--pmkinovar-color-theme-main": "255, 255, 255",
            "--pmkinovar-color-theme-main-lighter": "#b3b2b2",
            "--pmkinovar-color-theme-main-minor-transparent": "#e4e7e8cc",
            "--pmkinovar-color-theme-main-lighter-transparent": "#e4e7e866",
            "--pmkinovar-color-theme-main-contrast": "#000000",
            "--pmkinovar-color-theme-main-contrast-transparent": "#00000066",
            "--pmkinovar-color-theme-main-contrast-minor-transparent": "#000000bf",
            "--pmkinovar-color-typo": "#000000",
            "--pmkinovar-color-link-inactive": "#8f8e8e",
            "--pmkinovar-color-button-text": "#fff",
            "--pmkinovar-color-border": "#161616",
            "--pmkinovar-color-typo-muted": "#363636",
            "--pmkinovar-color-no-image": "#a7a7a7",
            "--pmkinovar-accent-color-background-dark-color": "#000000",
            "--pmkinovar-attribute-fill-color": "#000000",
            "--pmkinovar-attribute-movietimes-fill-color": "#000000",
            "--pmkinovar-showtimes-fill-color": "#000000",
            "--pmkinovar-attribute-movietimes-fill-color-invert": '#FFFFFF',
            "--pmkinovar-showtimes-fill-color-invert": '#FFFFFF'
        }
    //ARTHOUSE THEME
    } else if (theme_colors === "Arthouse") {
        cssVars = {
            ...cssVars,
            "--pmkinovar-custom_button_color" : custom_button_color ? custom_button_color : button_background_color_hover,
            "--pmkinovar-custom_button_color_hover" : custom_button_color_hover ? custom_button_color_hover : button_background_color,
            "--pmkinovar-custom_font_color" : custom_font_color && custom_font_color_color ? custom_font_color_color : arthouse_variant === "dark" ? "#FFFFFF" : '#000000',
            "--pmkinovar-button_background_color" : button_background_color,
            "--pmkinovar-button_background_color_hover" : button_background_color_hover,
            "--pmkinovar-button_border_style" : button_border_style ? button_border_style : '1px solid ' + button_background_color,
            "--pmkinovar-button_border_style_hover" : button_border_style_hover ? button_border_style_hover : '1px solid ' + button_background_color,
            "--pmkinovar-filter_button_background_color" : custom_button_color_gradient ? custom_button_color_gradient : button_background_color,
            "--pmkinovar-slider-background-default-color": getArthouseVariantSliderColor,
            "--pmkinovar-slider-background-colored-color": multitotal_style === 'colored' ? getArthouseVariantSliderColor : slider_background_color ? slider_background_color : "#181818",
            // old default colors
            "--pmkinovar-color-border-transparent" : arthouse_variant === "dark" ? '#ededed33' : '#18181833',
            "--pmkinovar-color-selection-main" : arthouse_variant === "dark" ? '#5c5c5c' : '#cecccc',
            "--pmkinovar-color-theme-main-transparent": arthouse_variant === "dark" ? "#ededed33" : "#ffffff80",
            "--pmkinovar-color-theme-main-more-transparent": arthouse_variant === "dark" ? '#15151559' : "#ffffff59",
            "--pmkinovar-color-theme-selektor-transparent": "#ffffff45",
            "--pmkinovar-color-theme-main-contrast-light-transparent": "#1818181a",
            //needs to be like this for rgba reasons - if varaible is used please write rgb() around
            "--pmkinovar-color-theme-main": "255, 255, 255",
            "--pmkinovar-color-theme-main-lighter": "#dfdfdf",
            "--pmkinovar-color-theme-main-minor-transparent": "#ffffffcc",
            "--pmkinovar-color-theme-main-lighter-transparent": arthouse_variant === 'dark' ? "#33363766" : "#e4e7e866",
            "--pmkinovar-color-theme-main-contrast": "#181818",
            "--pmkinovar-color-theme-main-contrast-transparent": "#18181866",
            "--pmkinovar-color-theme-main-contrast-minor-transparent": "#181818a6",
            "--pmkinovar-color-typo": arthouse_variant === "dark" ? '#FFFFFF' : "#181818",
            "--pmkinovar-color-link-inactive": "#8f8e8e",
            "--pmkinovar-color-button-text": "#000000",
            "--pmkinovar-color-border": "#161616",
            "--pmkinovar-color-typo-muted": "#363636",
            "--pmkinovar-color-no-image": "#F2F2F2",
            "--pmkinovar-accent-color-background-dark-color": arthouse_variant === "dark" ? '#FFFFFF' : "#181818",
            "--pmkinovar-attribute-fill-color": arthouse_variant === "dark" ? '#FFFFFF' : "#181818",
            "--pmkinovar-attribute-movietimes-fill-color": "#181818",
            "--pmkinovar-showtimes-fill-color": "#181818",
            "--pmkinovar-attribute-movietimes-fill-color-invert": arthouse_variant === "dark" ? '#FFFFFF' : "#181818",
            "--pmkinovar-showtimes-fill-color-invert": arthouse_variant === "dark" ? '#FFFFFF' : "#181818"
        }

    // OTHER THEMES (DARK/KMOTION)
    } else {
        if(overview_filter_style === 'clean') {
            cssVars = {
                ...cssVars,
                "--pmkinovar-filter_button_background_color" : 'transparent'
            }
        } else {
            cssVars = {
                ...cssVars,
                "--pmkinovar-filter_button_background_color" : custom_button_color_gradient ? custom_button_color_gradient : button_background_color
            }
        }

        cssVars = {
            ...cssVars,
            "--pmkinovar-custom_font_color" : custom_font_color && custom_font_color_color ? custom_font_color_color : '#FFFFFF',
            "--pmkinovar-custom_button_color" : custom_button_color ? custom_button_color : custom_font_color && custom_font_color_color ? custom_font_color_color : '#FFFFFF',
            "--pmkinovar-custom_button_color_hover" : custom_button_color_hover ? custom_button_color_hover : custom_font_color && custom_font_color_color ? custom_font_color_color : '#FFFFFF',
            "--pmkinovar-button_background_color" : custom_button_color_gradient ? custom_button_color_gradient : button_background_color,
            "--pmkinovar-button_background_color_hover" : custom_button_color_gradient_hover ? custom_button_color_gradient_hover : button_background_color_hover,
            "--pmkinovar-button_border_style" : button_border_style && button_border_style,
            "--pmkinovar-button_border_style_hover" : button_border_style_hover && button_border_style_hover,
            "--pmkinovar-slider-background-default-color": getArthouseVariantSliderColor,
            "--pmkinovar-slider-background-colored-color": multitotal_style === 'colored' ? getArthouseVariantSliderColor : slider_background_color ? slider_background_color : "#181818",
            // old default colors
            "--pmkinovar-color-border-transparent" :'#ededed33',
            "--pmkinovar-color-selection-main" :'#2d2d2d',
            "--pmkinovar-color-theme-main-transparent": "#00000080",
            "--pmkinovar-color-theme-main-more-transparent": "#00000059",
            "--pmkinovar-color-theme-selektor-transparent": "#00000045",
            "--pmkinovar-color-theme-main-contrast-light-transparent": "#ffffff1a",
            //needs to be like this for rgba reasons - if varaible is used please write rgb() around
            "--pmkinovar-color-theme-main": "0, 0, 0",
            "--pmkinovar-color-theme-main-lighter": "#191919",
            "--pmkinovar-color-theme-main-minor-transparent": "#1d1d1dcc",
            "--pmkinovar-color-theme-main-lighter-transparent": "#3b3b3b80",
            "--pmkinovar-color-theme-main-contrast": "#FFFFFF",
            "--pmkinovar-color-theme-main-contrast-transparent": "#ffffff66",
            "--pmkinovar-color-theme-main-contrast-minor-transparent": "#000000bf",
            "--pmkinovar-color-typo": "#ffffff",
            "--pmkinovar-color-link-inactive": "#626262",
            "--pmkinovar-color-button-text": "#fff",
            "--pmkinovar-color-border": "#ededed",
            "--pmkinovar-color-typo-muted": "#C9C9C9",
            "--pmkinovar-color-no-image": "#2d2d2d",
            "--pmkinovar-accent-color-background-dark-color": "#FFFFFF",
            "--pmkinovar-attribute-fill-color": "#FFFFFF",
            "--pmkinovar-attribute-movietimes-fill-color": "#FFFFFF",
            "--pmkinovar-showtimes-fill-color": "#FFFFFF",
            "--pmkinovar-attribute-movietimes-fill-color-invert": '#000000',
            "--pmkinovar-showtimes-fill-color-invert": '#000000'
        }
    }

    if(header_appearance === "partly_filled_with_color") {
        cssVars = {
            ...cssVars,
            "--pmkinovar-borlabs_accent_color_background" : accent_color_gradient ? accent_color_gradient :accent_color_background
        }
    } else {
        cssVars = {
            ...cssVars,
            "--pmkinovar-borlabs_accent_color_background" : accent_color_background
        }
    }

    return cssVars
}

export default useCssVars